module.exports = __webpack_public_path__ + "media/images/gallery/constellations/hercules/her_names-dbf487ba05ee1290a6c842934c602ab6.gif";